/** Default CORS proxy for isomorphic-git HTTP in the browser (same as upstream examples). */
export const GIT_HTTP_CORS_PROXY = "https://cors.isomorphic-git.org";

export const GIT_DEFAULT_REMOTE = "origin";

export const GIT_WORKDIR = ".";

export const GIT_GITDIR = ".git";
